import { createFileRoute } from "@tanstack/react-router";
import { PurchaseListPage } from "../../../../features/purchase-list/purchase-list-page";

export const Route = createFileRoute("/_auth/_project/purchases/$projectId/$subProjectId/")({
  component: PurchaseListPage,
});
